import React from "react";

const CustomWidgetBlock = ({block}) => {
    return (
        <section className="page-clock">
            <div dangerouslySetInnerHTML={{__html: block?.embedCode}} />
        </section>
    );
};

export default CustomWidgetBlock;
